import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { graphql, useStaticQuery } from "gatsby"

function Seo({ description, lang, meta, title, image, url}) {
	const { site } = useStaticQuery(
		graphql`
            query {
                site {
                    siteMetadata {
                        title
                        description
                        author
                    }
                }
            }
		`
	)
	
	const metaDescription = description || site.siteMetadata.description
	
	
	return (
		<Helmet
			htmlAttributes={{
				lang
			}}
			title={title}
			meta={[
				{
					name: `description`,
					content: metaDescription
				},
				{
					property: `og:title`,
					content: title
				},
				{
					property: `og:description`,
					content: metaDescription
				},
				{
					property: `og:url`,
					content: url
				},
				{
					property: `og:type`,
					content: `website`
				},
				{
					property: `og:image`,
					content: image
				},
				{
					name: `twitter:card`,
					content: `summary`
				},
				{
					name: `twitter:creator`,
					content: site.siteMetadata?.author || ``
				},
				{
					name: `twitter:title`,
					content: title
				},
				{
					name: `twitter:description`,
					content: metaDescription
				}
			].concat(meta)}
		/>
	)
}

Seo.defaultProps = {
	lang: `en`,
	meta: [],
	description: `Let's Celebrate - Chạm đến trái tim bằng sự sáng tạo`,
	title: "Let's Celebrate",
	image: "https://khan-web-prod.s3.ap-southeast-1.amazonaws.com/static/Cover-Lets-Celebrate.png"
}

Seo.propTypes = {
	description: PropTypes.string,
	lang: PropTypes.string,
	meta: PropTypes.arrayOf(PropTypes.object),
	title: PropTypes.string.isRequired
}

export default Seo
